// Front/src/pages/DivisionTable.js

import React from "react";
import { useLanguageContext } from "../context/LanguageContext";
import "../style/NewScale.css";
import translations from "../i18n/translations";

export const divisionData = [
    {
      divisionRange: {
        he: "מעל 100,000",
        en: "n > 100,000"
      },
      accuracyLevel: "1",
      min: "100d",
      id: 1,
    },
    {
      divisionRange: {
        he: "בין 10,000 ל־100,000",
        en: "10,000 ≤ n ≤ 100,000"
      },
      accuracyLevel: "2",
      min: "20d",
      id: 2,
    },
    {
      divisionRange: {
        he: "בין 1,000 ל־10,000",
        en: "1,000 ≤ n < 10,000"
      },
      accuracyLevel: "3",
      min: "20d",
      id: 3,
    },
    {
      divisionRange: {
        he: "עד 1,000",
        en: "n < 1,000"
      },
      accuracyLevel: "4",
      min: "10d",
      id: 4,
    },
];  

const DivisionTable = () => {
    const { language } = useLanguageContext();
    const t = translations[language];

    return (
      <div className="division-table-container">
        <table className="division-table">
          <thead>
            <tr>
                <th>{t.divisionN}</th>
                <th>{t.accuracyClassLabel}</th>
                <th>MIN</th>
            </tr>
          </thead>
          <tbody>
            {divisionData.map((row) => (
              <tr key={row.id}>
                <td>{row.divisionRange[language]}</td>
                <td>{row.accuracyLevel}</td>
                <td dir="ltr">{row.min}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  
export default DivisionTable;